"use strict";

exports.__esModule = true;
exports.ScrollableMetricChartYAxis = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Units = require("../../../../Catalogs/Units");
var _Axis = require("../../../Charts/Axis");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var YAxisWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ScrollableMetricChartYAxis__YAxisWrapper",
  componentId: "sc-eml1fd-0"
})(["svg > text{font-size:", "px;}"], function (props) {
  return props.height > 160 ? 14 : props.height < 120 ? 7 : 12;
});
var ScrollableMetricChartYAxis = exports.ScrollableMetricChartYAxis = /*#__PURE__*/_react["default"].memo(function (props) {
  var yScales = props.yScales,
    bodyWidth = props.bodyWidth,
    yAxisWidth = props.yAxisWidth,
    hideYUnits = props.hideYUnits,
    tickYFormat = props.tickYFormat,
    hideYAxis = props.hideYAxis,
    padding = props.padding,
    height = props.height;
  var heightWithPadding = height + 2 * padding;
  var axis = !hideYAxis && Object.keys(yScales).map(function (units, index) {
    var label = yScales[units].label;
    if (!label) {
      var unitDefinition = (0, _Units.getUnitDefinition)(units);
      label = unitDefinition.symbol ? unitDefinition.label + " (" + unitDefinition.symbol + ")" : unitDefinition.label;
      if (units === "MILLISECOND") {
        label = "Duration";
      } else if (units === "FRACTIONAL_PERCENT") {
        label = "Percentage (%)";
      }
    }
    return /*#__PURE__*/_react["default"].createElement(_Axis.Axis, {
      key: String(index),
      style: {
        overflow: "visible",
        position: "relative"
      },
      "data-testid": "YAxis",
      x: index === 0 ? 0 : bodyWidth + index * yAxisWidth,
      y: 0,
      padding: padding,
      height: heightWithPadding,
      width: yAxisWidth,
      tickValues: yScales[units].tickValues,
      scale: yScales[units].scale,
      orientation: index === 0 ? "LEFT" : "RIGHT",
      label: hideYUnits ? undefined : label,
      tickFormat: function tickFormat(value) {
        return tickYFormat(units, value);
      }
    });
  });
  return /*#__PURE__*/_react["default"].createElement(YAxisWrapper, null, axis);
});